import lodash from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Divider, Button, LinearProgress } from '@material-ui/core';
import { Row, Col } from 'antd';
import PreTransactionDetails from './PreTransactionDetails';
import PostTransactionDetails from './PostTransactionDetails';
import { SAVE_LEAD_PAYMENT_APPROVAL_DETAILS_DATA, VIEW_LEAD_PROFILE_URL } from '../../constants';
import { USER_GROUP_ADMIN, USER_GROUP_SUPER, USER_GROUP_CCM } from '../../../../../common/constants';

class PaymentApprovalDetails extends React.Component {
    handleClickSave = () => {
        const { dispatch, dataModel, $isNew } = this.props;

        dispatch({
            type: SAVE_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
            dataModel,
            op: $isNew ? 'Create' : 'Update',
            finId: dataModel._id,
        });
    }

    render() {
        const {
            sourceScreen,
            isLoading,
            user,
            data,
        } = this.props;
        const isLeadProfile = sourceScreen === VIEW_LEAD_PROFILE_URL;
        const purchApproved = lodash.get(data, 'bought_info.purchasing_team_approval.value');
        const transApproved = lodash.get(data, 'bought_info.transport_team_approval.value');
        const accApproved = lodash.get(data, 'bought_info.accounts_team_approval.value');
        const interExist = lodash.intersectionWith(
            user.groups,
            [USER_GROUP_ADMIN, USER_GROUP_SUPER, USER_GROUP_CCM],
            (userGroup, groupId) => (userGroup._id === groupId),
        );

        let formIsLocked = false;

        if (purchApproved && transApproved && accApproved) {
            formIsLocked = lodash.isEmpty(interExist);
        }

        const childProps = {
            ...this.props,
            formIsLocked,
        };

        return (
            <React.Fragment>
                {
                    isLeadProfile && isLoading && <LinearProgress style={{ marginTop: -16 }} />
                }
                <PreTransactionDetails {...childProps} />
                {
                    isLeadProfile && (
                        <React.Fragment>
                            <Divider style={{ margin: '10px 0' }} variant="middle" />
                            <PostTransactionDetails {...childProps} />
                            <Row style={{ marginTop: 10 }}>
                                <Col span={24}>
                                    <Button
                                        style={{ float: 'right' }}
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        disabled={formIsLocked || isLoading}
                                        onClick={this.handleClickSave}
                                    >
                                        Save finance data
                                    </Button>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    ...state.Leads.LeadPaymentApproval.approvalDetails,
    user: state.App.App_content.user,
});

export default connect(mapStateToProps)(PaymentApprovalDetails);



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/components/paymentApproval/PaymentApprovalDetails.js